/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Heart(props) {
	const group = useRef();
	const { nodes, materials } = useGLTF("models/Logos/Heart.glb");
	return (
		<group ref={group} {...props} dispose={null}>
			<mesh
				geometry={nodes.Logo_Heart.geometry}
				material={materials["Material.001"]}
				position={[-0.14, 3.12, -0.01]}
				rotation={[1.53, 0, 0]}
				scale={[57.43, 57.43, 57.43]}
			/>
		</group>
	);
}

useGLTF.preload("models/Logos/Heart.glb");
